import { BaseApi } from './base.api.js';

export class IncidentTemplateApi extends BaseApi {
    constructor(client) {
        super(client, '/incident-templates');
    }
}
